class IconCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.icon = options?.icon ? false
        @.relPath = options?.relPath ? false
        @.id = options?.id ? false
        @.desc = if options?.desc && @.id then options.desc else false
        @.title = if options?.title && @.id then options.id else false

        if @.icon
            @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElementNS 'http://www.w3.org/2000/svg', 'svg'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.classList.add 'icon'
        if @.id
            @.$el.id = @.id
        @.$el.innerHTML = "
            #{ if @.title then "<title id='#{ @.id }--title'>#{ @.title }</title>" else "" }
            #{ if @.desc then "<desc id='#{ @.id }--desc'>#{ @.desc }</desc>" else "" }
            <use xlink:href='#{ @.relPath ? '' }Icons/icons.svg#icon-#{ @.icon }'></use>
        "
        return

window.CreateIcon = (options) ->
    return new IconCreate options